<template >
  <div class="text-left container edit-user-form">
    Select user to edit
    <b-select v-model="user" :options="users"></b-select>
    <EditUser v-if="user.hasOwnProperty('id')" :user="user"/>
  </div>
</template>

<script>
import EditUser from './EditUser'
export default {
  name: 'AdminUsersIndex',
  components: {
    EditUser
  },
  data () {
    return {
      users: [],
      user: {}
    }
  },
  created () {
    this.getUsers()
  },
  methods: {
    getUsers () {
      var vm = this
      this.$http.get('/users')
        .then(function (response) {
          vm.users = response.data.map(function (user) {
            return {text: user.full_name, value: user}
          })
        })
        .catch(e => { console.log(e.response) })
    }
  }
}
</script>

<style scoped>
.edit-user-form {
  width: 80%;
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/users/Index.vue